CarouselVue(data-test='carousel' :total='programs.length' @index-updated='index => setCurrentIndex(index.value)')
  .fp-slider--image(v-for='(program, index) in programs' :key='index' :class='{"-active": index === currentIndex}' :data-test='`carousel.image-${index}`')
    router-link.fp-link.-no-text-decoration(:to='{ name: \'programPage\', params: { programSlug: program.slug } }')
      .fp-featured-content(data-test='image')
        FairplayerImageVue(:url='program.imageUrl' :resolution='ImageResolution.MD' :alt='program.name')
        .fp-featured-content--background
        .fp-featured-content--description
          .fp-text.-text-lg.-text-semi-bold(data-test='name') {{ program.name }}
